module.exports = __webpack_public_path__ + "img/L_312_0.d88a5e2d.png";